// components/BrandMark.tsx — sygnet BBK jako komponent.
//
// Wcześniej nagłówek rysował ikonę błyskawicy z lucide-react w gradientowym kwadracie
// (Header.tsx:216) — czyli szczyt strony pokazywał coś zupełnie innego niż favikona i awatary
// na TikToku. Znak musi być jeden.
//
// Ten plik jest ręcznym odpowiednikiem public/brand/logo-mark.svg. Ta sama geometria, ten sam
// układ 100x100. Przy zmianie znaku trzeba zaktualizować OBA — SVG jest źródłem dla eksportów
// (favikony, awatary), a ten komponent renderuje go w aplikacji bez dodatkowego żądania HTTP.

import React from 'react';

interface BrandMarkProps {
  className?: string;
  /** Kolor sylwetki kursora. Domyślnie dziedziczy z currentColor, żeby działał na jasnym i ciemnym tle. */
  inkClassName?: string;
}

export const BrandMark: React.FC<BrandMarkProps> = ({ className = 'w-8 h-8', inkClassName }) => (
  <svg
    viewBox="-17 -15.5 130 130"
    className={className}
    role="img"
    aria-label="Biznes bez Klikania"
    focusable="false"
  >
    <g fill="none" stroke="#0A84FF" strokeWidth="9" strokeLinecap="round">
      <line x1="6" y1="34" x2="26" y2="34" />
      <line x1="12" y1="50" x2="26" y2="50" />
      <line x1="18" y1="66" x2="26" y2="66" />
    </g>
    <path
      className={inkClassName ?? 'fill-[#111827] dark:fill-[#F9FAFB]'}
      d="M40 14
         L40 78
         a3 3 0 0 0 5.1 2.1
         L58 67
         L66.5 86
         a3 3 0 0 0 4 1.5
         l6.4 -2.9
         a3 3 0 0 0 1.5 -4
         L71.4 61.6
         L88 59.4
         a3 3 0 0 0 1.6 -5.2
         L45.1 11.9
         A3 3 0 0 0 40 14
         Z"
    />
  </svg>
);
